
/*
   ACL 제어

   - vue-authorize 모듈에 사용될 json format 생성
*/
var acls = {
  roles: {}
}

var length = Object.keys(window.vue.config.acl).length
for (var i = 0; i < length; i++) {
  var roleName = window.vue.config.role[i]
  var acl = window.vue.config.acl[roleName]

  if ( acl.handler ) {
    acl.handler = function () {
      return true
    }
  } else {
    acl.handler = function () {
      return false
    }
  }

  acls.roles[roleName] = acl
}

export default acls



// WEBPACK FOOTER //
// ./src/_fdp/core/directive/acl/acl.js